/* Dawn 15.4.0 – Infinite Scroll for collection pages
 * - Beholder filtre/sortering ved å følge servergenerert rel="next"
 * - Fallback til vanlig paginering hvis noe feiler
 */
(function () {
  // Sikre at vi kun kjører på kolleksjon (produktgrid finnes)
  function selectGridList(root) {
    // I din fil er UL med id="product-grid"
    if (!root) root = document;
    return (
      root.querySelector('ul#product-grid') ||
      root.querySelector('#ProductGridContainer ul') ||
      root.querySelector('[data-id][id="product-grid"]') ||
      root.querySelector('.product-grid ul, .collection ul#product-grid, ul.product-grid')
    );
  }

  function getState() {
    return {
      sentinel: document.querySelector('[data-infinite-sentinel]') || document.getElementById('InfiniteScrollSentinel'),
      statusEl: document.getElementById('InfiniteStatus'),
      nextLink: document.getElementById('PaginationNextLink'),
      list: selectGridList(document),
    };
  }

  let loading = false;
  let done = false;
  let observer = null;

  function announce(msg) {
    const { statusEl } = getState();
    if (statusEl) statusEl.textContent = msg || '';
  }

  async function loadNextPage() {
    if (loading || done) return;
    const { nextLink, list } = getState();
    if (!list) return;
    if (!nextLink || !nextLink.href) {
      cleanup(true);
      return;
    }

    loading = true;
    announce('Laster flere produkter …');

    try {
      const res = await fetch(nextLink.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextList = selectGridList(doc);
      if (!nextList) {
        cleanup(true);
        announce('Ingen flere produkter.');
        return;
      }

      const items = Array.from(nextList.children);
      if (!items.length) {
        cleanup(true);
        announce('Ingen flere produkter.');
        return;
      }

      const frag = document.createDocumentFragment();
      items.forEach((node) => frag.appendChild(node));
      list.appendChild(frag);

      // Finn neste rel=next i den nye siden
      const newNext = doc.getElementById('PaginationNextLink');
      if (newNext && newNext.href) {
        nextLink.href = newNext.href;
        // Oppdater URL "page" i historikken (valgfritt – forbedrer back/refresh)
        try {
          const url = new URL(newNext.href, window.location.origin);
          const lastPage = url.searchParams.get('page');
          if (lastPage) {
            const current = new URL(window.location.href);
            current.searchParams.set('page', String(Math.max(1, Number(lastPage) - 1)));
            history.replaceState({}, '', current.toString());
          }
        } catch (_) {}
      } else {
        // Ikke flere sider
        nextLink.remove();
        cleanup(true);
        announce('Alle produkter er lastet.');
      }
    } catch (err) {
      console.error('[InfiniteScroll] Hentefeil:', err);
      cleanup(false);
    } finally {
      loading = false;
      // Fjern status for å unngå at skjermleser gjentar
      setTimeout(() => announce(''), 300);
    }
  }

  function cleanup(isDone) {
    if (observer) observer.disconnect();
    if (typeof isDone === 'boolean') done = isDone;
  }

  function initObserver() {
    const { sentinel, nextLink, list } = getState();
    if (!sentinel || !list) return;
    if (!nextLink || !nextLink.href) return; // ingen neste side

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadNextPage();
        });
      },
      {
        rootMargin: '600px 0px 600px 0px',
        threshold: 0,
      }
    );
    observer.observe(sentinel);
  }

  function reinitAfterAjax() {
    // Når filtre/sortering i Dawn erstatter grid via AJAX,
    // vil elementene bli nye noder. Vi kobler til på nytt.
    loading = false;
    done = false;
    if (observer) observer.disconnect();
    initObserver();
  }

  // Init første gang
  document.addEventListener('DOMContentLoaded', initObserver);

  // Dawn bruker section-oppdateringer og facets-oppdateringer
  document.addEventListener('shopify:section:load', reinitAfterAjax);
  document.addEventListener('shopify:section:unload', reinitAfterAjax);
  document.addEventListener('facets:updated', reinitAfterAjax); // ekstra trygghet om eventet finnes
})();
